export enum UserType {
  ADMIN,
  TENANT,
}
